import React from 'react';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import TranslationService from '../../translations';
import { defaultOrganisationListingLogoUrl } from '../../../images/assets.json';
import {FilterGroupNames, Packages, PPSSortOrder} from '../../common/Constants';
import ExhibitorBronzePackage from './ExhibitorBronzePackage';
import ExhibitorPremiumPackage from './ExhibitorPremiumPackage';
import featureToggles from '../../common/featureToggle/featureToggles';

const isExhibitorInShowPlan = (exhibitorId, showPlan) => showPlan && showPlan.exhibitorIds && showPlan.exhibitorIds.includes(exhibitorId);

const isFollowing = (listOfNetworkFollowees, exhibitorWithoutCountryFilter) => {
  if (listOfNetworkFollowees !== undefined && listOfNetworkFollowees != null && exhibitorWithoutCountryFilter.organisationGuid != null) {
    return listOfNetworkFollowees.indexOf(exhibitorWithoutCountryFilter.organisationGuid) > -1;
  }
  return false;
};
const validFilters = (exhibitor) =>{
  let filters = {};
  Object.entries(exhibitor.filters).forEach(([question, value]) => {
    if (value) {
      const questionValueKeys = Object.keys(value);
      //Add questions with valid answer
      if (!(questionValueKeys.length === 1  && questionValueKeys.includes(PPSSortOrder))){
        filters[question] = value;
      }
    }
  });
  return filters;
}
const ExhibitorDirectoryListView = ({
  navigation, context, testVariants, baseApiUrl, exhibitors, showPlan, networkFollowees, digitalPortfolioId, isNetworkParticipant,
  handleFollowClick, userId, hideStandInfo, _tracker, showExhibitorRecommendation
}) => {
  const redesignedPackages = {
    [Packages.gold]: React.createFactory(ExhibitorPremiumPackage),
    [Packages.silver]: React.createFactory(ExhibitorPremiumPackage),
    [Packages.bronze]: React.createFactory(ExhibitorBronzePackage),
    [Packages.basic]: React.createFactory(ExhibitorBronzePackage)
  };

  if(context.isAbTestingEnabled && featureToggles.isFeatureEnabled(featureToggles.Keys.IS_AB_TESTING_ENABLED)){
    const sortedExhibitors = [];
    sortedExhibitors.push(...exhibitors.filter(x=>x.packageId===3)
    .sort((a, b) => {
      if (a.companyName.toLowerCase() > b.companyName.toLowerCase() )
          return 1;
      if (a.companyName.toLowerCase()  < b.companyName.toLowerCase() )
          return -1;
      return 0;
  }));
    sortedExhibitors.push(...exhibitors.filter(x=>x.packageId===2)
    .sort((a, b) => {
      if (a.companyName.toLowerCase()  > b.companyName.toLowerCase() )
          return 1;
      if (a.companyName.toLowerCase()  < b.companyName.toLowerCase() )
          return -1;
      return 0;
  }));
    sortedExhibitors.push(...exhibitors.filter(x=>x.packageId===1)
    .sort((a, b) => {
      if (a.companyName.toLowerCase()  > b.companyName.toLowerCase() )
          return 1;
      if (a.companyName.toLowerCase()  < b.companyName.toLowerCase() )
          return -1;
      return 0;
  }));
    sortedExhibitors.push(...exhibitors.filter(x=>x.packageId===4)
    .sort((a, b) => {
      if (a.companyName.toLowerCase()  > b.companyName.toLowerCase() )
          return 1;
      if (a.companyName.toLowerCase()  < b.companyName.toLowerCase() )
          return -1;
      return 0;
  }));
    exhibitors = sortedExhibitors;
  }

  return exhibitors.map((exhibitor, index) => {
    const exhibitorWithValidFilters = Object.assign({}, exhibitor);
    if (exhibitor.filters != null) {
      exhibitorWithValidFilters.filters = omit(exhibitor.filters, FilterGroupNames.CountryName);
      exhibitorWithValidFilters.filters = validFilters(exhibitorWithValidFilters);
    }

    const listOfNetworkFolloweesfromProp = networkFollowees;
    const translation = TranslationService.getTranslations(context.interfaceLocale);
    const props = {
      exhibitor: exhibitorWithValidFilters,
    translations: translation.directory,
      defaultLogoUrl: defaultOrganisationListingLogoUrl,
      detailPageLinkFormat: navigation.exhibitorPublicDetailsUrlFormat,
      testVariants,
      isInShowPlan: isExhibitorInShowPlan(exhibitor.id, showPlan),
      showPlanningEnabled: context.showPlanningEnabled,
      baseApiUrl,
      digitalPortfolioId,
      interfaceLocale: context.interfaceLocale,
      primaryLocale: context.primaryLocale,
      showFollowButton: isNetworkParticipant,
      isFollowing: isFollowing(listOfNetworkFolloweesfromProp, exhibitorWithValidFilters),
      handleFollowClick,
      userId,
      eventEditionId: context.eventEditionId,
      key: index,
      hideStandInfo,
      showExhibitorRecommendation,
      isMercuryParticipantShow: context.isMercuryParticipantShow,
      isPrioritySlotPremiumExhibitor: exhibitor.isPrioritySlotPremiumExhibitor ? true : false,
      navigation: navigation,
    };
    return redesignedPackages[exhibitor.packageId](props);
  });
};

ExhibitorDirectoryListView.propTypes = {
  exhibitors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    filters: PropTypes.object,
    packageId: PropTypes.number.isRequired,
    organisationGuid: PropTypes.string.isRequired
  })).isRequired,
  navigation: PropTypes.object.isRequired,
  context: PropTypes.shape({
    eventEditionId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired,
    showPlanningEnabled: PropTypes.bool,
    isAbTestingEnabled: PropTypes.bool,
    isMercuryParticipantShow:  PropTypes.bool.isRequired
  }).isRequired,
  testVariants: PropTypes.arrayOf(PropTypes.string),
  showPlan: PropTypes.object.isRequired,
  baseApiUrl: PropTypes.string.isRequired,
  networkFollowees: PropTypes.arrayOf(PropTypes.string),
  digitalPortfolioId: PropTypes.string,
  isNetworkParticipant: PropTypes.bool,
  handleFollowClick: PropTypes.func.isRequired,
  userId: PropTypes.string,
  hideStandInfo: PropTypes.bool,
  showExhibitorRecommendation: PropTypes.bool,
  tracker: PropTypes.object,
};

export default ExhibitorDirectoryListView;
